import React from "react";
import NavBar from "../../components/navBar/NavBar";
//import Chat from "../../components/chat/Chat.js";
import CardTask from "../../components/card/CardTask";
import "../../assets/style/style.css";
import axios from "axios";
import Moment from "react-moment";
import "moment/locale/pt-br";
import io from "socket.io-client";
import "./style.css";

Moment.globalLocale = "pt-br";

require("dotenv").config();
const url = process.env.REACT_APP_API_TASK;

const urlSocket = process.env.REACT_APP_API_SOCKET;
const socket = io(urlSocket);
class TaskAll extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tasks: []
    };
  }

  componentDidMount = () => {
    this.getTask();
    this.socketStart();
  };

  socketStart = () => {
    socket.on("newTask", msg => {
      console.log("mobile - " + msg);
      this.getTask("socket");
    });
  };

  getTask = async action => {
    const objForm = {
      tecnico: "All Nett",
      token: localStorage.getItem("token"),
      user: localStorage.getItem("user")
    };

    const response = await axios.post(`${url}/atividades`, {
      objForm: objForm
    });
    console.log(response);
    if (action === "socket") {
      console.log(response);
      this.setState(
        {
          tasks: []
        },
        () => {
          this.setState({
            tasks: response.data.resulAtividades
          });
        }
      );
    } else {
      this.setState({
        tasks: response.data.resulAtividades
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <NavBar />

        <div className="container-fluid container_body">
          <div className="containerCard ">
            {/*
              <button
                onClick={pedirPermissaoParaReceberNotificacoes}
                className="btn btn-secondary"
              >
                Receber Notificação
              </button>
            */}
            <br></br>
            <br></br>

            {this.state.tasks.length === 0 ? (
              <h4 align="center">Você não possui tarefas no momento.</h4>
            ) : (
              <h4 align="center">Tarefas Pendente</h4>
            )}
            {this.state.tasks.map((task, i) =>
              task.empresa ? (
                <CardTask
                  key={i}
                  id_task={task.id}
                  idTaskPrincipal={task.id_task}
                  title={task.empresa}
                  type={task.tipo_servico}
                  description={task.descricao}
                  tecnico={task.tecnico}
                  dataAgendada={task.data_agendada}
                  horaAgendada={task.hora_agendada}
                  status={task.status}
                />
              ) : task.pop ? (
                <CardTask
                  key={i}
                  id_task={task.id}
                  idTaskPrincipal={task.id_task}
                  title={task.pop}
                  type={task.tipo_servico}
                  description={task.descricao}
                  tecnico={task.tecnico}
                  dataAgendada={task.data_agendada}
                  horaAgendada={task.hora_agendada}
                  status={task.status}
                />
              ) : (
                <CardTask
                  key={i}
                  id_task={task.id}
                  idTaskPrincipal={task.id_task}
                  title="Allnet"
                  type="atividade_interna"
                  description={task.descricao}
                  tecnico={task.tecnico}
                  dataAgendada={task.data_agendada}
                  horaAgendada={task.hora_agendada}
                  status={task.status}
                />
              )
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default TaskAll;
